module.exports = __webpack_public_path__ + "static/favicon.04951258.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Metadata/favicon.png
// module id = 516
// module chunks = 114276838955818